import { Card, Divider, Popconfirm } from "antd";
import ActivityLoaderMintbox from "Components/ActivityLoaderMintbox";
import { CardHeader } from "Components/Atoms/CardHeader";
import React from "react";
import { AiFillEdit } from "react-icons/ai";
import { toast } from "react-toastify";
import AdminServicesPYV2 from "services/api/AdminServicesPYV2";
import EditKBArticle from "./EditKBArticle";

export default function AllKBArticles() {

    const [allArticles, setAllArticles] = React.useState([]);
    const [articlesLoading, setArticlesLoading] = React.useState(true);
    const [isEditing, setIsEditing] = React.useState(false);
    const [selectedArticle, setSelectedArticle] = React.useState({});

    const getAllArticles = async () => {
        let res2 = await AdminServicesPYV2.getAllKnowledgeBaseArticles();
        if (res2?.type) {
            if (res2?.data?.length > 0) {
                setAllArticles(JSON.parse(res2?.data)?.filter((el) => el?.IsDeleted !== 1));
            }
        }
    }

    const loadInitData = async () => {
        setArticlesLoading(true);
        await getAllArticles();
        setArticlesLoading(false);
    }

    const handleDelete = async (id) => {
        let data = {
            "params": JSON.stringify({ "UID": id })
        }
        let res = await AdminServicesPYV2.deleteKnowledgeBaseArticle(data)
        if (res.type) {
            toast.info('Article deleted!');
        }
        await getAllArticles();
    }

    React.useEffect(() => {
        loadInitData();
    }, []);

    return (
        <React.Fragment>
            {!isEditing ? <>
                <Card style={{ padding: 0 }} bodyStyle={{ padding: "1rem" }}>
                    <div className='d-flex justify-content-between flex-column flex-md-row ' style={{ gap: "10px" }}>
                        <CardHeader heading={"All articles"} />
                    </div>
                    <Divider style={{ margin: "1rem 0" }} />
                    {articlesLoading ? <div>
                        <ActivityLoaderMintbox />
                    </div> : <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "1.25rem" }}
                        className='margin20Top'>
                        {allArticles?.map((item, i) => (
                            <Card style={{ padding: "0rem", background: "var(--grey3)", border: "1px solid var(--grey2)" }} hoverable={false} key={i}
                                bodyStyle={{ height: "100%", padding: "1rem" }}>
                                <div className="d-flex flex-column justify-content-between" style={{ gap: "0.5rem", height: "100%" }}>
                                    <div className="d-flex flex-column" style={{ gap: "0.5rem" }}>
                                        <div className='textMD w-500'>
                                            {item.Title}
                                        </div>
                                        <Divider style={{ margin: "0" }} />
                                        <div className='textSM'>
                                            {item.Description}
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end" style={{ gap: "0.75rem" }}>
                                        <Popconfirm title='Are you sure you want to delete this article?' onConfirm={() => {
                                            handleDelete(item?.UID);
                                        }}>
                                            <button className="btnRed">
                                                Delete
                                            </button>
                                        </Popconfirm>
                                        <button className="btnPrimary d-flex align-items-center justify-content-center" style={{ gap: "0.25rem" }} onClick={() => {
                                            setSelectedArticle(item);
                                            setIsEditing(true);
                                        }}>
                                            <AiFillEdit /> Edit
                                        </button>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>}
                </Card>
            </> : <>
                <EditKBArticle selectedArticle={selectedArticle} allArticles={allArticles} onSuccess={async () => {
                    setIsEditing(false);
                    setSelectedArticle({});
                    await getAllArticles();
                }} onCancel={() => {
                    setIsEditing(false);
                    setSelectedArticle({});
                }} />
            </>}
        </React.Fragment>
    )
}